import { render, staticRenderFns } from "./body-card-item.vue?vue&type=template&id=77966c3c&scoped=true&"
import script from "./body-card-item.vue?vue&type=script&lang=ts&"
export * from "./body-card-item.vue?vue&type=script&lang=ts&"
import style0 from "./body-card-item.vue?vue&type=style&index=0&id=77966c3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77966c3c",
  null
  
)

export default component.exports